import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-overflow-tooltip",
    imports: [JumpstartComponentsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { style: "display: none" },
    template: `
        <portal-pds3 elementId="wk-app__root">
            <tooltip-pds3
                mode="description"
                position="top"
                [openDelay]="400"
                [closeDelay]="50"
                [targetSelector]="targetSelector()"
                flowClass="wk-dropdown-wrapper-tooltip"
            >
                {{ text() }}
            </tooltip-pds3>
        </portal-pds3>
    `,
})
export class WkOverflowTooltipComponent {
    public readonly targetSelector = input.required<string>();
    public readonly text = input.required<string>();
}
